/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './scheduleAction.defs.js'
export { main as default } from './scheduleAction.defs.js'
